"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = interactionConfig;

var _testApplicable = _interopRequireDefault(require("./testApplicable"));

function interactionConfig(descriptors) {
  var findDescriptor = function findDescriptor(type) {
    return descriptors.find(function (descriptor) {
      return descriptor.type === type;
    });
  };

  var isApplicable = function isApplicable(type, applicabilityConfig) {
    if (!type) {
      return false;
    }

    var descriptor = findDescriptor(type);

    if (descriptor == null) {
      return false;
    }

    return (0, _testApplicable.default)(descriptor.applicable, applicabilityConfig);
  };

  return {
    getAllDescriptors: function getAllDescriptors() {
      return descriptors;
    },
    getDescriptor: function getDescriptor(type) {
      return findDescriptor(type);
    },
    getDefault: function getDefault(localType, defaultType, applicabilityConfig) {
      if (isApplicable(defaultType, applicabilityConfig)) {
        return defaultType;
      }

      if (isApplicable(localType, applicabilityConfig)) {
        return localType;
      }

      return descriptors.first().type;
    },
    activate: function activate(type) {
      return this.getDescriptor(type).onActivated();
    }
  };
}

module.exports = exports.default;